export const isHttp = (href: string) => /^https?:\/\//i.test(href);
export const isSpecialScheme = (href: string) => /^(mailto:|tel:|sms:|whatsapp:)/i.test(href);
